// General functions

export function isNullOrUndefined(value) {
    return value === null || value === undefined;
}

export function isNullOrUndefinedOrBlank(value) {
    return value === null || value === undefined || `${value}`.replace(/\s+/g, '') === "";
}

export function isNullOrUndefinedOrBlankOrEmpty(value) {
    return value === null || value === undefined || `${value}`.replace(/\s+/g, '') === "" || (Array.isArray(value) && value.length === 0);
}


export async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}